import isAnalyticsEnabled from "@/utils/isAnalyticsEnabled.js";
import ReactGA from 'react-ga4';
import {useLocation} from "react-router-dom";

export default function initialiseGA() {
    if (isAnalyticsEnabled()) {
        ReactGA.initialize('G-8TJR82NTFJ')
        let location = useLocation()
        ReactGA.send({hitType: 'pageview', page: location.pathname});
    }
}